var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlan1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6606_8589",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 49,
    height: 48
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.0625,
    width: 48,
    height: 48,
    fill: "url(#pattern0_6606_8589)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6606_8589)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.0625,
    width: 48,
    height: 48,
    fill: "#FF928E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_6606_8589",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_6606_8589",
    transform: "scale(0.0078125)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_6606_8589",
    width: 128,
    height: 128,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIAAAACACAYAAADDPmHLAAAGfUlEQVR4Ae2dSc7kRBSEg2HHcAJGqaFZAEsmCYkTwLIFAgmOAleASzQIegGIQcACEH0EhjViwdB0I2DF+OAPqTqr7HLaObyXFZZKrwar6mVE2PX9afsvQIsUkAJSQApIASkgBaSAFJACUkAKSAEpIAXGVuABAJcA/Hx2exPA+bGHrNFRgfsAXAHwd3L7CcA5rqQ6rgK25afm8/Fb4w5bIzMF7gTwx0wA/gRwt6QaV4FXZsznXuDlcYd/2iO7GcC3CwLwHQBbV8tgCjyzwHzuBZ4ebOwaDoB3MwLwjhQbS4Fj8Mctn1UwOJb/WAJ/NJ9VMDhICJbCH41nFQwOEoAc+KP5rILBAUKQA380nlUwGDwAufBH41kFg8EDsAb+aD6rYDBoCNbCH41nFQwGDcAW+KP5rILBgCHYAn80nlUwGCwAW+GPxrMKBoMFoAT80XxWwWCQEJSCPxrPKhgMEoCS8EfzWQWDAUJQEv5oPKtg0HkASsMfjWcVDJ4F4H4AdgbtrwCuAngDwOMOwmGgRrNqVQ8waFqb5j+c6X+x5SntdlGFnUN/SOD3OwahFvyl47TzCu2zeixmvGmc9mSPv28Vgrnz6tlYjyAYoPHza9fWMDhn/O5YbU9QfbmWIXTLIBig7YpR834rGFxqPMdqe+bqy6HLqtjAVK0dhLuOXPAx1dfa5+3iEvvMWkuu8RyHeVN9ubxhS/scwFMVOqwx80dRp2oNGHwMwNsb9P2igrZ7b/nahgYpZskgtII/9s5acmZwq/Hs6dU9tyo88VKBALDhEkGoOfPHPqfqVhgsZTz7e7GC33tv+VDBALDxLUGoOfPH/qbqWhgsbTz7e3DPrQpP3ATgtwohsEHkBqH2zB+Fnaq5M4O1jLf+zJNm8xNbQHBKzN3nlwahB/zt9mn3l8BgTePZTxMA5A6lBAiy8bk6F4Re8Jf2OweDLYxnP00AkAEoCYIcwFw9FISe8Jf2msJgS+PZSxMAZABqgCAHMld3g9AT/tIeCYM9jGcvTQCQAbDd7++VQJADmqsfNZ75m+vFXrOZQevp2Hq1XjcvmgEgQ1AbBGuJNeL7NgVABqAVCI5oWOkxNQVABqA1CJYWbaT3awqADEAvEBzJuFJjaQqADEDNGcFSwpzC+zSdAaT5rALBfuTPcHcBQAZAINg/AF0AkAEQCPYPQBcAZAAEgv0D0AUAGYDeM4L8HsypfwF4D8AFAHec3ey+nbdor+W8V+91u8wA0nzWSCD4FYBH2PiB+iiArwOFwLTvvkQBwU8B3LJArVsBfBYkBKZ99yUCCH4J4LYMpW4Psicw7bsvDzvfWux7/YkVKj0ZgAlM++6L9xlBg7u1y8eOw911BjAV1DMIPps2m/H4eccBcAGA1NIzCN7DJldU+xWx3n/qTX1+1xnAVEuvIGjf/zekzWY8vtFxAFwAILX0PCPIHtdUC8/UFtj7+a4zgKmYnkEw7TXnsdcAuAJACuoRBEf9CnAFgAyAVxC8lw2uqPYzs7139Yc+3xUAUlevIPgcG1xRX3AaAFcASF29guCHbHBF/cRpAFwBIHX1emh4tKlgF4eAaXpaPYKgfYfawSA7wLN08XwwyCUAUlivIGghsMPBdqj32GJHDe0axEPw5eE5F4eAp0T0CoI0zk72sJM+pha7uPMbx+bbOFwCIAX1fmjYBDQm+ODf4/12kMj+w4jd7L49Z68xLF6ri0PANDytnmcEvRqa05fLGcA0BF5BMEdor+t2vQgkNXrqsWcQ9Grs0r5czgCmQfAOgkvF9rhe14tAUqOnHnudEfRoaG5PLmcA0yAIBOv8JRECABkGgWD5EIQAQAZAIFg+ACEAkAEQCJYPQAgAZAAEguUDEAIAGQCBYNkAhAJAhkAgWC4EoQCQARAIlgtAKABkAASC5QIQCgAZAIFguQCEAkAGQCBYJgAhAZAhUJUCUkAKSAEpIAWkgBSQAlJACkgBKSAFTkuB3PPetP71E0jh0yJDrzc0Vw8FIMDlWrmm5qyvACgAsTOQk3atu/91Edv9E996SwRaATjxECkACkDsDJTYDZ7ye8R2/8S33hLBVQBOPEQKgAIQOwO/nLiBW74Grsa2/v/uLykAq//z2MURAnAewBWFIDsEP579qukIGfjvf/G9DuCagnA0CKaRbfn2s7ZapIAUkAJSQApIASkgBaSAFJACUkAKSAEpIAWkgBSQAlJACkgBKbBJgX8AfoBDtctnprEAAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlan1);
export default __webpack_public_path__ + "static/media/plan-1.a0dc961668d3f0c593d6cddc6a76b636.svg";
export { ForwardRef as ReactComponent };